import multiguard from 'vue-router-multiguard'
import middleware from './middlewares/index'

export default [

  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('../components/cookpit/Invoices.vue'),
    beforeEnter: multiguard([
      middleware.mustBeSeller,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/invoice/:id',
    name: 'invoices',
    component: () => import('../components/invoices/InvoiceDetails'),
    beforeEnter: multiguard([
      middleware.mustBeSeller,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/invoices/add-new',
    name: 'invoices',
    component: () => import('../components/invoices/AddNewInvoice'),
    beforeEnter: multiguard([
      middleware.mustBeSeller,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('../components/cookpit/UploadDocs.vue'),
    beforeEnter: multiguard([
      middleware.mustBeSeller,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientTradeOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/referral-program',
    name: 'referralProgram',
    component: () => import('../components/cookpit/ReferralProgram.vue'),
    beforeEnter: multiguard([
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientTradeOnly,
      middleware.ClientDepositWithdraw,
      middleware.referralProgramActive,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/annual-activity-summary',
    name: 'annual-activity-summary',
    component: () => import('../components/seller-reports/AnnualActivitySummary.vue'),
    beforeEnter: multiguard([
      middleware.mustBeSeller,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => import('../components/billing/BillingInformation.vue'),
    beforeEnter: multiguard([
      middleware.mustBeSeller,
      middleware.UserActive,
      middleware.ClientTradeOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
      role: 'seller',
    },
  },
]
